import { CANCEL_TASK, CANCEL_TASK_SUCCESSFUL, CANCEL_TASK_FAILED } from './actionTypes';

export const cancelTask = (task,response, token,history) => {
    return {
        type: CANCEL_TASK,
        payload: { task,response,token, history }
    }
}

export const cancelTaskSuccessful = (msg) => {
    return {
        type: CANCEL_TASK_SUCCESSFUL,
        payload: msg
    }
}

export const cancelTaskFailed = (msg) => {
    return {
        type: CANCEL_TASK_FAILED,
        payload: msg
    }
}
